export class UserSettings {
  isNativeClientEnabled?: boolean;
}
